export const ticketCategories = [
    {
        key: 'Admin Portal',
        text: 'Admin Portal',
        data: {
            vsoAreaPath: 'Admin Portal',
            driAlias: 'ctdri',
        },
    },
    {
        key: 'Analyst Support',
        text: 'Analyst Support',
        data: {
            vsoAreaPath: 'Analyst Support',
            driAlias: 'expanalysisdri',
        },
    },
    {
        key: 'Control Tower, Experiments, and ExpAPI',
        text: 'Control Tower, Experiments, and ExpAPI',
        data: {
            vsoAreaPath: 'Control Tower',
            driAlias: 'ctdri',
        },
    },
    {
        key: 'Metrics',
        text: 'Metrics',
        data: {
            vsoAreaPath: 'Vivace',
            driAlias: 'ctdri',
        },
    },
    {
        key: 'Scorecards Compute',
        text: 'Scorecard Compute',
        data: {
            vsoAreaPath: 'Scorecards',
            driAlias: 'AnEChinaTeam@service.microsoft.com',
        },
    },
    {
        key: 'Treatment Assignment',
        text: 'Treatment Assignment',
        data: {
            vsoAreaPath: 'Treatment Assignment',
            driAlias: 'exp-ta',
        },
    },
    {
        key: 'XCard',
        text: 'xCard',
        data: {
            vsoAreaPath: 'XCard',
            driAlias: 'ctdri-anacon',
        },
    },
];
export default ticketCategories;

//# sourceMappingURL=TicketCategories.js.map
